import React, { useEffect, useState } from "react";

const Benefits_RxAuthorizations = () => {
    return (
        <div>
           <h2>Benefits_RxAuthorizations</h2>
        </div>
    );
};

export default Benefits_RxAuthorizations;